import * as React from "react";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { Spinner } from "../../../../react-core/Html/Spinner";
import { TrophyIcon } from "./TrophyIcon";

export interface IConfirmationProps {
    onExit: () => void;
    successMessage: string;
    errorMsg?: string;
    isLoading: boolean;
    buttonLabel?: string;
    accountNumberMessage?: string;
}

export class Confirmation extends BaseComponent<IConfirmationProps, null> {
    constructor(props: any) {
        super(props);
    }

    private renderLoading() {
        return (
            <div className="text-center">
                <h3>Submitting your applications</h3>
                <p>This could take a couple of minutes, please don't move away from this screen</p>
                <Spinner notFull={true} />
            </div>
        );
    }

    render() {
        const { isLoading, buttonLabel, errorMsg, successMessage } = this.props;
        if (isLoading) {return this.renderLoading();}
        const btnLabel = buttonLabel || "Back to dashboard";
        return (
            <div className="text-center mb-54">
                <h2>{CommonHelper.isNullOrEmpty(errorMsg) ? "Success!" : "Error!"}</h2>
                <p>{CommonHelper.isNullOrEmpty(errorMsg) ? successMessage : errorMsg}</p>
                {this.props.accountNumberMessage && <p className="mb-43">{this.props.accountNumberMessage}</p>}
                {CommonHelper.isNullOrEmpty(errorMsg) && <TrophyIcon cssWrapper="large" />}

                <div className="text-center pt-64 pb-64 mt-10 mb-25" onClick={() => this.props.onExit()}>
                    <a className="next-button" href="javascript:void(0);">
                        <span aria-hidden="true" className="icon"></span>
                        <span className="text">{btnLabel}</span>
                    </a>
                </div>
            </div>
        );
    }
}
